// extracted by mini-css-extract-plugin
export default {"form_style":"ContactForm_form_style__VILWu","input":"ContactForm_input__kV8vG","label_astrix":"ContactForm_label_astrix__XkFAD","submitButton":"ContactForm_submitButton__zYpow"};